<template>
  <div class="field parent-field">
    <label class="label has-text-left">{{label}}</label>
    <div class="control has-icons-left has-icons-right">
      <textarea @input="updateValue" @change="updateValue" v-model="value" :class="['textarea', classes ]"></textarea>
    </div>
    <p class="help">{{description}}</p>
  </div>
</template>


<script>
export default {
    data() {
        return {
            value: "",
        }
    },
    methods: {
      updateValue() {
      this.$emit("input", this.value);
    },
    },
    props: {
        label: {
            type: String,
            required: true,
            default: "Enter"
        },
        left_icon: {
            type: String,
            default: null,
        },
        description: {
          type: String,
          required: false,
          default: null,
        },
        classes: {
          type: Object,
          required: false,
        },
        valid: {
          type: Boolean,
          required: false,
        }
    }
};
</script>


<style scoped>

.parent-field {
  margin: 0.5rem;
}

.textarea {
  border: 2px solid #dcdcdc;
}
</style>